import common from './common-educabot'

export default {
  ...common.button,
  color: `#FFFFFF`,
  '::before': {
    display: `none`
  },
  '::after': {
    ...common.button['::after'],
    bg: `#01CEAA`,
    border: '0.5px solid',
    borderColor: `#01CEAA`
  }
}